import { faXmark } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { SanityPopIn } from 'graphql-types';
import React, { useEffect, useState } from 'react';
import { usePageContext } from '../context/pageContext';
import { CTA } from '../html-tag/Cta';
import * as styles from './PopIn.module.scss';
import { GatsbyImage } from 'gatsby-plugin-image';
import { findTranslation } from '../../utils/findTranslation';

export const PopIn: React.FC<{ data: SanityPopIn; pageId: string }> = ({ data, pageId }) => {
  const [isOpened, setIsOpened] = useState<boolean>(false);
  const [displayed, setDisplayed] = useState<boolean>(false);

  const { lang, defaultLang } = usePageContext();

  useEffect(() => {
    let wasDisplayed = sessionStorage.getItem(`pop_in_displayed__[${pageId}]`) === 'true';

    sessionStorage.setItem(`pop_in_displayed__[${pageId}]`, `${wasDisplayed}`);

    if (!wasDisplayed) {
      setIsOpened(true);
    }

    setDisplayed(wasDisplayed);
  }, []);

  const youtubeIdParser = (url: string) => {
    const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
    const match = url.match(regExp);
    return match && match[7].length == 11 ? match[7] : false;
  };

  const handleClick = () => {
    setIsOpened(false);
    sessionStorage.setItem(`pop_in_displayed__[${pageId}]`, 'true');
  };

  return (
    <>
      {data.enabled && !displayed && isOpened && (
        <div className={styles.wrapper}>
          <div
            className={styles.overlay}
            onClick={() => {
              handleClick();
            }}
          />
          <div className={styles.modal}>
            <div className={styles.titleWrapper}>
              <h1>{findTranslation(data._rawTitle, lang, defaultLang)}</h1>
              <FontAwesomeIcon
                onClick={() => {
                  handleClick();
                }}
                icon={faXmark}
                color={'orange'}
                size={'2x'}
                className={styles.closeIcon}
              />
            </div>
            {data.image?.asset?.gatsbyImageData && (
              <div className={styles.imageWrapper}>
                <GatsbyImage
                  image={data.image?.asset?.gatsbyImageData}
                  alt={'therapeutic applications'}
                />
              </div>
            )}
            {data.videoUrl && (
              <div className={styles.videoWrapper}>
                <iframe
                  width="853"
                  height="480"
                  src={`https://www.youtube.com/embed/${youtubeIdParser(data.videoUrl)}?rel=0`}
                  allowFullScreen
                  title="Embedded youtube"
                />
              </div>
            )}
            {data._rawDescription && (
              <p className={styles.description}>
                {findTranslation(data?._rawDescription, lang, defaultLang)}
              </p>
            )}
            {data._rawCtaLink && data._rawCtaLabel && (
              <div className={styles.ctaWrapper}>
                <CTA
                  label={findTranslation(data?._rawCtaLabel, lang, defaultLang)}
                  onClick={() => {
                    handleClick();
                  }}
                  dataType={'orange'}
                  to={findTranslation(data._rawCtaLink, lang, defaultLang)}
                />
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
};
